export enum MediaListItemProperties {
  Name = 'name',
  MediaType = 'mediaType',
  MediaUrl = 'mediaUrl',
  Description = 'description',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum MediaListItemMetaProperties {}
